<section style="padding: 20px;">
  <h2>Search Audit</h2>
  <gen-dynamic-form
    class="audit-search-form"
    [formConfig]="auditSearchFormConfig"
    [formData]=""
    [formVertical]="true"
    [submitted]=""
    [submitButtonText]="'Search'"
    [popupMode]="true"
    (submitEmitter)="searchAudit($event)">
  </gen-dynamic-form>
  <hr/>
  <div>&nbsp;</div>
  <ng-container *ngIf="auditResponse">
    <ng-container *ngIf="auditResponse.success; else ResponseFailed">
       <style>
        .hidden-json-content{
          display: none;
        }

        .visible-json-content{
          display: block;
        }

        .json-content-popup{
          z-index: 100; position: absolute; top: 20px;left: 20px; height: 800px;width: 1000px;
        }
      </style>
      <gen-worklist
          class="table-wrapper Auto_Curation_List"
          [resource]="'AUDIT_V2_VIEWER_TEMPLATE'"
          [actions]="[]"
          [values]="auditViewItem"
          [trackByField]="'itemIndex'"
          [injectedActions]="[]"
          [load]="true"
          [isInfiniteTotalCounting]="true"
          (rowClicked)="onItemClick($event.data)"
      ></gen-worklist>



    </ng-container>



  </ng-container>
</section>

<ng-template #ResponseFailed>
  <div id="auditFailResponse">{{auditResponse.responseBody}}</div>
  <!-- The response was bad show body here -->
</ng-template>
